import { Caption, CustomNavLink, Title } from "../common/Design";
import { CiGrid41 } from "react-icons/ci";
import { IoSettingsOutline } from "react-icons/io5";
import { MdOutlineCategory } from "react-icons/md";
import { RiAuctionLine } from "react-icons/ri";
import { IoIosHeartEmpty } from "react-icons/io";
import { User1 } from "../hero/Hero";
import { IoIosLogOut } from "react-icons/io";
import { CgProductHunt } from "react-icons/cg";
import { TbCurrencyDollar } from "react-icons/tb";
import { FiUser } from "react-icons/fi";
import { FaPlusCircle } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import { AutoApprovalToggle } from "../../admin/AutoApprovalToggle";


export const Sidebar = () => {
  const location = useLocation();
  const logOut = async (e) => {
    e.preventDefault();
    localStorage.clear();
    window.location.href = `${process.env.REACT_APP_BASE_URL}login`;



  }

  const role = "admin";
  const className = "flex items-center gap-3 p-4 mb-2 rounded-full";

  return (
    <>
      <section className="flex flex-col justify-between h-full sidebar">
        <div className="flex items-center justify-between p-4 mb-2 rounded-full bg-white overflow-visible">

          <img src={User1} alt="" className="object-cover w-32 h-32 rounded-full" />
          <div>
            <Title className="capitalize">Sunil B.K</Title>
            <Caption>example@gmail.com</Caption>
          </div>
        </div>

        <div>
          <CustomNavLink href="/dashboard" isActive={location.pathname === "/dashboard"} className={className}>
            <span>
              <CiGrid41 size={22} />
            </span>
            <span>Dashbaord</span>
          </CustomNavLink>
          <CustomNavLink href="/hutch-message-count" isActive={location.pathname === "/dashboard"} className={className}>
            <span>
              <MdOutlineCategory size={22} />
            </span>
            <span>Hutch 10.30 SMS</span>
          </CustomNavLink>

          {(role === "seller" || role === "admin") && (
            <>
              <CustomNavLink href="/add" isActive={location.pathname === "/add"} className={className}>
                <span>
                  <FaPlusCircle size={22} />
                </span>
                <span>Add Alert Contents</span>
              </CustomNavLink>
              <CustomNavLink href="/userlist" isActive={location.pathname === "/userlist"} className={className}>
                <span>
                  <RiAuctionLine size={22} />
                </span>
                <span>All Contents</span>
              </CustomNavLink>

              <CustomNavLink href="/schedule-upload" isActive={location.pathname === "/schedule-upload"} className={className}>
                <span><MdOutlineCategory size={22} /></span>
                <span>Upload Schedule</span>
              </CustomNavLink>

              <CustomNavLink href="/count-upload" isActive={location.pathname === "/count-upload"} className={className}>
                <span><TbCurrencyDollar size={22} /></span>
                <span>Upload Count</span>
              </CustomNavLink>
              <div className="flex items-center gap-3 p-4 mb-2 rounded-full bg-gray-50">
                <AutoApprovalToggle />
              </div>
            </>
          )}







          <button onClick={logOut} className="flex items-center w-full gap-3 p-4 mt-4 mb-3 text-white bg-red-500 rounded-full hover:text-white">
            <span>
              <IoIosLogOut size={22} />
            </span>
            <span>Log Out</span>
          </button>
        </div>

        <div>
        </div>

      </section>
    </>
  );
};
